import React from "react";
import './Topbar.css';

const Topbar = () => {
  return (
    <div className="topbar">
      <div className="topbar-contact">
        <a href="mailto:info@company.com">
          <i className="fas fa-envelope"></i> info@company.com
        </a>
        <a href="tel:+911234567890">
          <i className="fas fa-phone"></i> +91 12345 67890
        </a>
      </div>
    </div>
  );
};

export default Topbar;